import { memo } from 'react';
import type { ReactNode } from 'react';

const ProductPlaceholderIndicator = ({ children }: { children: ReactNode }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 114 114"
        >
            <g transform="translate(-1379 -3020)">
                <rect
                    fill="#fafafa"
                    width="114"
                    height="114"
                    transform="translate(1379 3020)"
                />
                <g transform="translate(969.725 2029.105)">
                    <path
                        fill="none"
                        stroke="#707070"
                        strokeWidth="0.25px"
                        d="M2402.49,1048h107.783"
                        transform="translate(-2011.591 2043.876) rotate(-45)"
                    />
                    <path
                        fill="none"
                        stroke="#707070"
                        strokeWidth="0.25px"
                        d="M0,0H107.782"
                        transform="translate(504.488 1086.107) rotate(-135)"
                    />
                </g>
                <rect
                    fill="#fafafa"
                    width="90"
                    height="21"
                    transform="translate(1391 3066)"
                />
                <text
                    fill="#707070"
                    fontSize="9px"
                    fontFamily="Roboto"
                    fontWeight="500"
                    transform="translate(1380 3021)"
                >
                    <tspan
                        x="50%"
                        y="50%"
                        textAnchor="middle"
                        alignmentBaseline="middle"
                    >
                        {children}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};

export default memo(ProductPlaceholderIndicator);
